export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-thumbnail-v1-480-e0e804128dbd984cf05deb20f8a352b3.png";